import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { ChevronDown, ChevronUp, Copy } from "lucide-react";
import { useNavigate } from "react-router";
import QRCode from "qrcode";
import { SetupLayout } from "./SetupLayout";
import { Button } from "../../primitives/Button";
import { Input } from "../../primitives/Input";
import { useAuth } from "../../provider";
import { useAuthConfig } from "../../config";
export function SetupMFAQRCode() {
    const navigate = useNavigate();
    const { authClient } = useAuth();
    const { brandName } = useAuthConfig();
    const [showSecret, setShowSecret] = useState(false);
    const [copied, setCopied] = useState(false);
    const [secretKey, setSecretKey] = useState("");
    const [qrDataUri, setQrDataUri] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const setup = async () => {
            try {
                const res = await authClient.initiateMFASetup();
                const secret = res.data.secret_code;
                setSecretKey(secret);
                const encodedBrand = encodeURIComponent(brandName);
                const otpauthUri = `otpauth://totp/${encodedBrand}?secret=${secret}&issuer=${encodedBrand}`;
                const dataUri = await QRCode.toDataURL(otpauthUri, {
                    width: 200,
                    margin: 1,
                });
                setQrDataUri(dataUri);
            }
            catch (err) {
                setError(err instanceof Error ? err.message : "Failed to load MFA setup");
            }
            finally {
                setIsLoading(false);
            }
        };
        setup();
    }, [authClient, brandName]);
    const handleCopy = () => {
        navigator.clipboard.writeText(secretKey);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };
    return (_jsx(SetupLayout, { currentStep: 1, children: _jsxs("div", { className: "text-center", children: [_jsx("h1", { className: "text-duvi-text-primary mb-3", style: {
                        fontSize: "var(--text-xl)",
                        fontWeight: "var(--font-weight-semibold)",
                        lineHeight: "var(--line-height-heading)",
                    }, children: "Scan with your authenticator app" }), _jsx("p", { className: "text-duvi-text-secondary mb-8", style: {
                        fontSize: "var(--text-sm)",
                        lineHeight: "var(--line-height-body)",
                    }, children: "Open your authenticator app and scan this QR code." }), _jsx("div", { className: "flex justify-center mb-6", children: _jsx("div", { className: "bg-white rounded-[8px] p-2 inline-block", children: isLoading ? (_jsx("div", { className: "w-40 h-40 flex items-center justify-center text-duvi-text-secondary", style: { fontSize: "var(--text-sm)" }, children: "Loading..." })) : error ? (_jsx("div", { className: "w-40 h-40 flex items-center justify-center text-duvi-destructive", style: { fontSize: "var(--text-sm)" }, children: error })) : (_jsx("img", { src: qrDataUri, alt: "MFA QR Code", className: "w-40 h-40" })) }) }), _jsxs("button", { onClick: () => setShowSecret(!showSecret), className: "flex items-center gap-2 text-duvi-accent hover:text-duvi-accent/80 transition-colors mx-auto mb-4", style: { fontSize: "var(--text-sm)" }, children: ["Can't scan?", showSecret ? (_jsx(ChevronUp, { className: "w-4 h-4" })) : (_jsx(ChevronDown, { className: "w-4 h-4" }))] }), showSecret && (_jsxs("div", { className: "mb-6", children: [_jsxs("div", { className: "relative", children: [_jsx(Input, { value: secretKey, readOnly: true, className: "font-mono text-center", style: { fontFamily: "monospace" } }), _jsx("button", { onClick: handleCopy, className: "absolute right-3 top-1/2 -translate-y-1/2 text-duvi-text-secondary hover:text-duvi-text-primary transition-colors", title: "Copy secret key", children: _jsx(Copy, { className: "w-4 h-4" }) })] }), copied && (_jsx("div", { className: "text-duvi-success mt-2", style: { fontSize: "var(--text-xs)" }, children: "Copied to clipboard" }))] })), _jsx(Button, { variant: "primary", className: "w-full", onClick: () => navigate("/setup/mfa/verify"), children: "I've scanned it" })] }) }));
}
//# sourceMappingURL=SetupMFAQRCode.js.map